module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_43-be4867627bf274480acda137db2a21f0.png";